import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as HsnActions from "./hsn.actions";
import { catchError, map, mergeMap, of } from "rxjs";
import { HsnService } from "app/modules/masters/hsn-code/hsn.service";

@Injectable()
export class HsnEffects {
  constructor(
    private actions$: Actions,
    private hsnService: HsnService
  ) {}

  // Load all HSN codes
  loadHsns$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HsnActions.loadHsns),
      mergeMap(() =>
        this.hsnService.getAll().pipe(
          map(
            (hsn) => HsnActions.loadHsnSuccess({ hsn })
          ),
          catchError((error) =>
            of(HsnActions.loadHsnFailure({ error: error.message }))
          )
        )
      )
    )
  );

  // Create a new HSN code
  createHsn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HsnActions.createHsn),
      mergeMap(({ hsn }) =>
        this.hsnService.create(hsn).pipe(
          map((created) => HsnActions.createHsnSuccess({ hsn: created })),
          catchError((error) =>
            of(HsnActions.createHsnFailure({ error: error.message }))
          )
        )
      )
    )
  );

  // Reload HSN list after successful creation
  reloadAfterCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HsnActions.createHsnSuccess),
      map(() => HsnActions.loadHsns())
    )
  );
}
